// import { DatePicker } from "libraries/components/date-picker/date-picker";
import LoadingSpinnerScreen from "src/libraries/components/loading-spinner/loading-spinner.screen";
import { EmptyProductIcon } from "src/libraries/icons/icon";
import { Bar } from "react-chartjs-2";
import { TransactionStatisticAdapter } from "./transaction-statistic.adapter";
import "./transaction-statistic.scss";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const transactions = [
  { date: "2024-12-18", status: "Success", count: 69 },
  { date: "2024-12-18", status: "Pending", count: 96 },
  { date: "2024-12-18", status: "Cancelled", count: 21 },
  { date: "2024-12-19", status: "Success", count: 55 },
  { date: "2024-12-19", status: "Pending", count: 42 },
  { date: "2024-12-19", status: "Cancelled", count: 11 },
  { date: "2024-12-20", status: "Success", count: 98 },
  { date: "2024-12-20", status: "Pending", count: 12 },
  { date: "2024-12-20", status: "Cancelled", count: 20 },
  { date: "2024-12-21", status: "Success", count: 22 },
  { date: "2024-12-21", status: "Pending", count: 67 },
  { date: "2024-12-21", status: "Cancelled", count: 38 },
  { date: "2024-12-22", status: "Success", count: 86 },
  { date: "2024-12-22", status: "Pending", count: 11 },
  { date: "2024-12-22", status: "Cancelled", count: 31 },
  { date: "2024-12-23", status: "Success", count: 12 },
  { date: "2024-12-23", status: "Pending", count: 55 },
  { date: "2024-12-23", status: "Cancelled", count: 31 },
  { date: "2024-12-24", status: "Success", count: 44 },
  { date: "2024-12-24", status: "Pending", count: 22 },
  { date: "2024-12-24", status: "Cancelled", count: 55 },
];
const TransactionStatisticComponent = () => {
  function onlyUnique(value: string, index: number, array: any) {
    return array.indexOf(value) === index;
  }
  const dates = transactions.map((transaction) => transaction.date);
  const uniqueDates = dates.filter(onlyUnique);
  console.log("unique", uniqueDates);

  const statuses = ["Success", "Pending", "Cancelled"];
  // const { transactionReport, loading, t } = TransactionStatisticAdapter();

  const chartColors = ["#FF4C54", "#03BD5B", "#4A90E2", "#F5A623"];
  const chartColors2 = ["#FFB8BB", "#84FFBE", "#ABDCFF", "#FFE985"];
  const datasets = statuses.map((status, index) => {
    const data = uniqueDates.map((date) => {
      const transaction = transactions.find(
        (t) => t.date === date && t.status === status
      );
      return transaction ? transaction.count : 0; // Nếu không có dữ liệu, trả về 0
    });
    return {
      label: status,
      data,
      barThickness: 50,
      backgroundColor:
        status === "Success"
          ? "rgba(75, 192, 192, 0.7)"
          : status === "Pending"
          ? "rgba(255, 205, 86, 0.7)"
          : "rgba(255, 99, 132, 0.7)", // Màu sắc khác nhau cho từng trạng thái
    };
  });
  const chartData = {
    labels: uniqueDates, // Trục X (ngày giao dịch)
    datasets: datasets,
  };

  const options = {
    responsive: true,

    legend: {
      position: "top" as const,
    },
    title: {
      display: true,
      text: "Transaction Status by Date",
    },
    scales: {
      x: {
        stacked: true,
        // Chồng dữ liệu theo trục X
      },
      y: {
        stacked: true, // Chồng dữ liệu theo trục Y
        beginAtZero: true, // Bắt đầu từ 0
      },
    },
  };
  // const data = {
  //   maintainAspectRatio: false,
  //   responsive: true,
  //   // labels: [t("dashboard.failed"), t("dashboard.succeed")],
  //   datasets: [
  //     {
  //       // data: [
  //       //   transactionReport?.totalFailedTransaction,
  //       //   transactionReport?.totalSuccessedTransaction,
  //       // ],
  //       backgroundColor: chartColors2,
  //       borderColor: chartColors,
  //       borderWidth: 2,
  //       hoverBackgroundColor: chartColors,
  //     },
  //   ],
  // };
  // const pieOptions = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   legend: {
  //     display: false,
  //     position: "right",
  //     align: "end",

  //     usePointStyle: true,
  //     boxWidth: 10,
  //   },

  //   elements: {
  //     arc: {
  //       borderWidth: 0,
  //     },
  //   },
  // };

  // const renderCardStatistic = (
  //   label: any,
  //   value: any,
  //   color: string,
  //   total?: number
  // ) => {
  //   return (
  //     <div className="card-statistics-detail">
  //       <span className="value" style={{ color: color }}>
  //         {value}{" "}
  //         {total && <span>({((value / total) * 100).toFixed(0)}%)</span>}
  //       </span>
  //       <span
  //         className="label"
  //         style={{ color: color, display: "flex", alignItems: "center" }}
  //       >
  //         {label}{" "}
  //         {total && (
  //           <div
  //             style={{
  //               width: "30px",
  //               height: "15px",
  //               backgroundColor: color,
  //               marginLeft: "5px",
  //             }}
  //           />
  //         )}
  //       </span>
  //     </div>
  //   );
  // };
  return (
    <div className="transaction-statistic-container">
      <div className="transaction-statistic-header">
        <div>
          <span className="title">{"Lượng giao dịch"}</span>
        </div>
      </div>

      <div className="transaction-statistic-body">
        <div className="chart-ctn">
          <div className="pieChart">
            <Bar data={chartData} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionStatisticComponent;
